const getters = {
  menuActive: state => state.app.menuActive,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js